module.exports = __webpack_public_path__ + "img/nucleo-icons.dc0cdfac.svg";